import { gql } from '@apollo/client'
import React from 'react'

import { generalClient } from '../../../../utils/apollo/api'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../packages/kiti/components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useScreenState = () => React.useContext(Context)
export const useScreen = () => useScreenState()?.screen

const QUERY = gql`
  query Screen($id: ID) {
    screen(id: $id) {
      id
      name
      screen
      data
    }
  }
`

const ScreensLoader = ({ children, id }) => {
  const { data, ...state } = useQuery(QUERY, {
    variables: { id },
    client: generalClient
  })

  const [screen, setScreen] = React.useState(data?.screen || {})
  React.useEffect(() => {
    setScreen(data?.screen || {})
  }, [data?.screen])

  return (
    <StatePresenter {...state}>
      <Provider value={{ ...data, screen, setScreen }}>{children}</Provider>
    </StatePresenter>
  )
}

export default ScreensLoader
